import React from 'react'
import { connect } from 'react-redux'
import mbLogo from '../images/GovMB_Logo.png';
import vsLogo from '../images/VeroSource-logo.png';

class Footer extends React.Component {

  render() {
    return (
      <div className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div class="vsLogo"><img src={vsLogo} alt="VeroSource Solutions Inc." width="90" /></div>
              <div className="leftFooter"><a href={this.props.strings.TOU_LINK} target="_blank">{this.props.strings.TOU}</a>  |  <a href={this.props.strings.PRIVACY_LINK} target="_blank">{this.props.strings.PRIVACY}</a>  |  <a href={this.props.strings.FAQ_LINK} target="_blank">{this.props.strings.FAQ}</a></div>
              <div className="leftFooterMobile"><a href={this.props.strings.TOU_LINK} target="_blank">{this.props.strings.TOU}</a>  |  <a href={this.props.strings.PRIVACY_LINK} target="_blank">{this.props.strings.PRIVACY}</a>  |  <a href={this.props.strings.FAQ_LINK} target="_blank">{this.props.strings.FAQ}</a></div>
              <div class="mbFooterLogo"><img src={mbLogo} width="115" /></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.language.language,
    strings: state.language.strings,
  }
}
const ConnectedFooter = connect(
  mapStateToProps,
)(Footer);
export default ConnectedFooter;
